import React from "react";
import { Helmet } from 'react-helmet';

// Translate
import { Translation  } from 'react-i18next';

// Components
import Page404 from '../../../components/system/Errors/404';

class System404 extends React.Component {
    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {

        return (
            <div>
                <Translation ns={'template'}>
                    {
                        (t) => <Helmet title={t('page_404')} />
                    }
                </Translation>
                <Page404 />
            </div>
        );
    }
}

export default System404;
